import { getAuthAxiosBackend } from "@/helpers/axios"
import { PersonServices } from "@/services/personServices"

class SacrificerServices extends PersonServices{

    getFamilyByPersonId(id){
        return getAuthAxiosBackend().get('familyRelationship/getFamilyPerson/' + id)
    }
}

export { SacrificerServices };
export default new SacrificerServices();